import { createRouter, createWebHashHistory } from "vue-router";
import main from "../views/main.vue";
import { ElNotification } from "element-plus";

const routes = [
	{
		path: "/",
		name: "main",
		component: main,
		children: [
			{
				path: "/",
				name: "home",
				component: () => import("../views/home/home.vue"),
			},
			{
				path: "/customer",
				name: "customer",
				component: () => import("../views/customer/customer.vue"),
			},
			{
				path: "/dict_name",
				name: "dict_name",
				component: () => import("../views/customer/dict_name.vue"),
			},
			{
				path: "/dict_corp",
				name: "dict_corp",
				component: () => import("../views/customer/dict_corp.vue"),
			},
			{
				path: "/dict_internal",
				name: "dict_internal",
				component: () => import("../views/customer/dict_internal.vue"),
			},
			{
				path: "/dict_law",
				name: "dict_law",
				component: () => import("../views/customer/dict_law.vue"),
			},
			{
				path: "/dict_media",
				name: "dict_media",
				component: () => import("../views/customer/dict_media.vue"),
			},
			{
				path: "/dict_risk",
				name: "dict_risk",
				component: () => import("../views/customer/dict_risk.vue"),
			},
			{
				path: "/dict_status",
				name: "dict_status",
				component: () => import("../views/customer/dict_status.vue"),
			},
			{
				path: "/dict_type",
				name: "dict_type",
				component: () => import("../views/customer/dict_type.vue"),
			},
			{
				path: "/config_right",
				name: "config_right",
				component: () => import("../views/customer/config_right.vue"),
			},
			{
				path: "/config_shortcut",
				name: "config_shortcut",
				component: () => import("../views/customer/config_shortcut.vue"),
			},
			{
				path: "/qxbmlb",
				name: "qxbmlb",
				component: () => import("../views/pzx/qxbmlb.vue"),
			},
			{
				path: "/qxyhlb",
				name: "qxyhlb",
				component: () => import("../views/pzx/qxyhlb.vue"),
			},
		],
	},
	{
		path: "/login",
		name: "login",
		component: () => import("../views/login/login.vue"),
	},
	{
		path: "/404",
		name: "404",
		component: () => import("@/views/noPage/404.vue"),
	},
	{
		path: "/linkLog",
		name: "linkLog",
		component: () => import("@/views/noPage/linkLog.vue"),
	},
	{
		path: "/:catchAll(.*)",
		redirect: "/404",
	},
];

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

const whiteList = ["login", "linkLog"];
router.beforeEach((to, from, next) => {
	if (localStorage.getItem("token")) {
		next();
	} else {
		if (whiteList.indexOf(to.name) !== -1) {
			next();
		} else {
			ElNotification({
				title: "系统提示",
				message: "未登录，请登录",
				type: "error",
				duration: 3000,
			});
			next({ path: "/login" });
		}
	}
});
export default router;
